<template lang="pug">
  base-node(:data="data" :nodeType="IQ_TOOL_ACTION_TYPE_COMMAND")
    template(#icon)
      i.iq-ico-building-kit-command
</template>

<script>
import BaseNode from './BaseNode.vue';
import { IQ_TOOL_ACTION_TYPE_COMMAND } from '@/constants/iqtool';

export default {
  name: 'DiagramCommandNode',
  components: {
    BaseNode,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      IQ_TOOL_ACTION_TYPE_COMMAND,
    };
  },
};
</script>

<style scoped>
  .command-node-wrapper {
    border-color: #008254;
  }
  .iq-ico-building-kit-command::before {
    background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 15 15' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 2.8125C0 1.25977 1.25977 0 2.8125 0C4.36523 0 5.625 1.25977 5.625 2.8125V3.75H9.375V2.8125C9.375 1.25977 10.6348 0 12.1875 0C13.7402 0 15 1.25977 15 2.8125C15 4.36523 13.7402 5.625 12.1875 5.625H11.25V9.375H12.1875C13.7402 9.375 15 10.6348 15 12.1875C15 13.7402 13.7402 15 12.1875 15C10.6348 15 9.375 13.7402 9.375 12.1875V11.25H5.625V12.1875C5.625 13.7402 4.36523 15 2.8125 15C1.25977 15 0 13.7402 0 12.1875C0 10.6348 1.25977 9.375 2.8125 9.375H3.75V5.625H2.8125C1.25977 5.625 0 4.36523 0 2.8125ZM3.75 3.75V2.8125C3.75 2.29395 3.33105 1.875 2.8125 1.875C2.29395 1.875 1.875 2.29395 1.875 2.8125C1.875 3.33105 2.29395 3.75 2.8125 3.75H3.75ZM5.625 9.375H9.375V5.625H5.625V9.375ZM3.75 11.25H2.8125C2.29395 11.25 1.875 11.6689 1.875 12.1875C1.875 12.7061 2.29395 13.125 2.8125 13.125C3.33105 13.125 3.75 12.7061 3.75 12.1875V11.25ZM11.25 11.25V12.1875C11.25 12.7061 11.6689 13.125 12.1875 13.125C12.7061 13.125 13.125 12.7061 13.125 12.1875C13.125 11.6689 12.7061 11.25 12.1875 11.25H11.25ZM11.25 3.75H12.1875C12.7061 3.75 13.125 3.33105 13.125 2.8125C13.125 2.29395 12.7061 1.875 12.1875 1.875C11.6689 1.875 11.25 2.29395 11.25 2.8125V3.75Z' fill='%23008254'/%3E%3C/svg%3E");
    background-size: contain;
    background-repeat: no-repeat;
    width: 10px;
    height: 10px;
  }
</style>